
import {
  defineComponent, ref, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import Loader from '@/components/layout/Loader.vue';
import ProgressSpinner from 'primevue/progressspinner';
import Tooltip from 'primevue/tooltip';
import { TemplatesCustom } from '@/types/generated-types/graphql';

// Extended interface to include name_marketing_workflow from GraphQL response
interface ExtendedTemplatesCustom extends TemplatesCustom {
  name_marketing_workflow?: string;
}

export default defineComponent({
  name: 'TemplateGridView',

  components: {
    Button,
    Loader,
    ProgressSpinner,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    list: {
      type: Array as PropType<ExtendedTemplatesCustom[]>,
      required: true,
    },

    isListLoading: {
      type: Boolean,
      required: true,
    },

    baseUrl: {
      type: String,
      required: true,
    },

    idShop: {
      type: Number,
      required: true,
    },

    imageLoadTime: {
      type: Object as PropType<Record<number, number>>,
      required: true,
    },

    selectedTemplates: {
      type: Set as PropType<Set<number>>,
      required: true,
    },

    isElementPartTypeSection: {
      type: Boolean,
      required: true,
    },

    getSelectedSectionsForTemplate: {
      type: Function as PropType<(templateId: number) => string[]>,
      required: true,
    },
  },

  emits: ['handle-scroll', 'image-loaded', 'image-failed', 'preview-image', 'toggle-selection'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const scrollContainer = ref<HTMLElement>();
    const previewLoading = ref<Record<number, boolean>>({});

    const handleScroll = (event: Event) => {
      emit('handle-scroll', event);
    };

    const imageLoaded = (id: number) => {
      emit('image-loaded', id);
    };

    const imageFailed = (id: number) => {
      emit('image-failed', id);
    };

    const handlePreviewImageWithLoading = (record: ExtendedTemplatesCustom) => {
      previewLoading.value[record.id_template] = true;

      emit('preview-image', {
        id: record.id_template,
        templateType: record.type,
        templateLabel: record.label,
      }, () => {
        previewLoading.value[record.id_template] = false;
      });
    };

    const toggleSelection = (id: number) => {
      emit('toggle-selection', id);
    };

    return {
      t,
      scrollContainer,
      previewLoading,
      handleScroll,
      imageLoaded,
      imageFailed,
      handlePreviewImageWithLoading,
      toggleSelection,
    };
  },
});
